
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component({
  name: 'AppButton',
  components: {

  }
})
export default class AppButton extends Vue {
  @Prop({ required: true })
  private id: string;

  @Prop({ required: true })
  private value: boolean;

  private handleInput(e: { target: HTMLInputElement }) {
    this.$emit('input', e.target.checked);
  }
}
